import { IBienLaiThuViewModel } from "../../../model/respone/bien-lai/IBienLaiThu";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IBienLaiPrintRequest } from "./IBienLaiViewChiTietActionTypes";
export interface IBienLaiViewTheoLopChiTietBaseActionTypes<T> {
  request: number;
  data: T;
}

export const eBienLaiViewTheoLopChiTietActionsObj = {
  LOAD_START: {} as number,
  LOAD_SUCCESS: {} as IBienLaiThuViewModel[],
  LOAD_ERRR: {} as IBienLaiViewTheoLopChiTietBaseActionTypes<string>,

  PRINT_START: {} as IBienLaiPrintRequest,
  PRINT_SUCCESS: {} as IBienLaiViewTheoLopChiTietBaseActionTypes<string>,
  PRINT_ERR: {} as IBienLaiViewTheoLopChiTietBaseActionTypes<string>,
};
export const eBienLaiViewTheoLopChiTietActionTypeIds = generateActionTypeIds(
  eBienLaiViewTheoLopChiTietActionsObj,
  "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET"
);
export type IBienLaiViewTheoLopChiTietActionTypes = IGenericActionType<
  typeof eBienLaiViewTheoLopChiTietActionsObj,
  "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET"
>;
